import { GetEmployeeAccessDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export const useEmployeeAccess = (employeeId?: number) => {
  const { data, loading } = useQuery(GetEmployeeAccessDocument, {
    variables: { employeeId: Number(employeeId) },
    skip: !employeeId,
  })
  return {
    loading,
    accessId: data?.employees.employee?.access?.id,
  }
}
